import React from 'react'
import { Menu, Icon } from 'semantic-ui-react'
import moment from 'moment'

const AppFooter = () => {
   return (
      <React.Fragment>
         <Menu secondary className="app-footer">
            <Menu.Item>Mayapur <Icon name='copyright outline' size='small' /> {moment().format('YYYY')}</Menu.Item>
            <Menu.Menu position='right'>
               <Menu.Item>
                  <a href="http://sysm.in/" target="_blank">Sysm Technology</a>
               </Menu.Item>
            </Menu.Menu>
         </Menu>
      </React.Fragment>
   )
}

export default AppFooter